export default "__VITE_ASSET__ioDc4aRc__"